import React, { useEffect } from 'react';
import {
  ExclamationIcon,
  ExclamationCircleIcon,
  XCircleIcon,
  CheckCircleIcon,
  XIcon,
} from '@heroicons/react/solid';
import {
  useCommonDispatch,
  useCommonSelector,
} from '@wajeez-web/stores/common';
import { AlertType } from '@wajeez-web/stores/common';
import { CommonActions } from '@wajeez-web/stores/common';
import { ReturnTranslatedText } from '@wajeez-web/core/localization';

const Alert = () => {
  const { type, messages } = useCommonSelector((state) => state.common.alert);
  const dispatch = useCommonDispatch();
  const getColor = () => {
    switch (type) {
      case AlertType.WARNING:
        return 'yellow';

      case AlertType.SUCCESS:
        return 'green';
      case AlertType.INFO:
        return 'blue';
      case AlertType.ERROR:
        return 'red';
    }
    return;
  };
  const getBgColor = () => {
    switch (type) {
      case AlertType.WARNING:
        return 'bg-yellow-50';

      case AlertType.SUCCESS:
        return 'bg-green-50';
      case AlertType.INFO:
        return 'bg-blue-50';
      case AlertType.ERROR:
        return 'bg-red-50';
    }
    return;
  };

  const getIcon = () => {
    switch (type) {
      case AlertType.WARNING:
        return <ExclamationIcon className="h-5 w-5 text-yellow-500 " />;

      case AlertType.SUCCESS:
        return <CheckCircleIcon className="h-5 w-5 text-green-500 " />;
      case AlertType.INFO:
        return <ExclamationCircleIcon className="h-5 w-5 text-blue-500 " />;
      case AlertType.ERROR:
        return <XCircleIcon className="h-5 w-5 text-red-500 " />;
    }
    return;
  };
  useEffect(() => {
    if (messages && messages.length > 0) {
      setTimeout(() => {
        dispatch(CommonActions.clearAlert());
      }, 2000);
    }
  }, [messages]);

  return (
    <div
      className={`fixed  top-5  w-auto min-w-[300px] justify-center   mx-auto z-50 space-y-2 ltr:right-5 rtl:left-5`}
    >
      {messages &&
        messages.map((item, i) => (
          <div
            key={item.code + i}
            className={` text-${getColor()}-500 text-sm  overflow-clip border border-${getColor()}-500 ${getBgColor()} p-4 flex flex-row align-middle justify-between w-full rounded-md`}
          >
            <div className="flex flex-row space-s-2  overflow-clip w-full">
              {getIcon()}{' '}
              <div className=" overflow-clip w-full">
                <ReturnTranslatedText
                  text={`general.${item.message}`}
                  origintext={item.message || ''}
                />
              </div>
            </div>
            <XIcon
              onClick={() => dispatch(CommonActions.clearAlert())}
              className={`text-${getColor()}-500 cursor-pointer hover:text-${getColor()}-400 h-4 w-4`}
            />
          </div>
        ))}
    </div>
  );
};

export default Alert;
